export const hotelRegulationsText = {
    "en-US": `<b>1. Check-In:</b> Starts at 17:00 on the day of arrival.

<b>2. Check-Out:</b> Must be completed by 10:00 on the day of departure.
• Luggage can be left for later collection by prior arrangement with management if guests wish to spend the day in Flims, Laax, or Falera.

<b>3. Smoking:</b> Smoking is not allowed inside any of the apartments.

<b>4. Tourist Taxes:</b>
• CHF 5 per adult per night (from age 13).
• Children aged 12 and under are exempt.

<b>5. Noise:</b>
• No loud music or other noise is permitted between 22:00 and 08:00.

<b>6. Saunas:</b> Must be left clean and turned off upon departure.

<b>7. Log Fire (Apartment Fuorcla):</b> May only be used after receiving instructions from management on the day of arrival.

<b>8. Sports Equipment:</b>
• Ski boots, skis, snowboards, and mountain bikes are not allowed inside any of the apartments.
• Use the ski room located by the entrance in House A for storage.
• Mountain bikes must be spray-cleaned outside before being stored in the ski room.

<b>9. Pets:</b>
• Dogs are allowed by prior arrangement for fee of 50 CHF. Not all dog breeds are allowed.

<b>10. Parties:</b> No parties are allowed in the apartments unless prior approval is obtained from management.

<b>11. Wi-Fi Usage:</b> All guests must agree to the online privacy and data terms and conditions when using the Black Summit in-house Wi-Fi.

<b>12. Parking:</b>
• <b>Outdoor Parking:</b>
• There are 12 parking spots located outside, in front of the building, by the barrier on the right as you enter the property.
• Parking for studio guests is also located in this area.
• <b>E-Car Charging Stations:</b>
• Three electric car charging stations are available for all apartments (and studios, subject to availability and upon payment) in the underground garage.
• <b>Underground Parking:</b>
• Six underground garage parking spaces are available for apartment guests, subject to availability.
• These spaces are always reserved for disabled guests requiring wheelchair access.
• <b>Snow Clearing:</b>
• On Saturdays during the ski season, all cars must be moved from parking spaces by 10:00 to allow for snow clearing.

<b>13. Damages:</b> Any damages must be reported to management prior to departure.

<b>14. Rubbish Disposal:</b>
• Dispose of rubbish using the green Laax paid rubbish bags during your stay and before departure.
• Disposal locations:
• Rubbish drop opposite the property (via the underpass under the main road to Via Marcau).
• Alternatively, exit the property, turn right, and walk approximately 100m along Via Cons to another rubbish and glass depository.

<b>15. Bus Stop Access (Macau):</b>
• For safety, cross Via Cons opposite the dentist’s office and use the underpass south of the roundabout to reach the bus stop.
• Do not cross the barriers or the main road directly opposite the Black Summit property.

<b>16. Wellness Facilities:</b>
• Please observe the separate wellness rules for using the swimming pool, Jacuzzi, and steam room.
`};
